module.exports = __webpack_public_path__ + "img/odd-numbered-pages.2408407.svg";